import React from "react";
import ReactDOM from "react-dom";

import { FlagGroup, IFlagGroupColor } from "@multiweb/reactComponents";
import { FlagUtils } from "Global/Base/Utils/FlagUtils";
import { Enum } from "OW.Remoting/Remoting/DataTypes/Enums";
import { Flags } from "OW.Remoting/Remoting/DataTypes/Flags";
import { registerCustomElement } from "UI/UI.ElementarControls/Utils/CustomElementUtils";
import { Control } from "../../../../../UI.BaseControls/Control";

/** Zobrazuje seznam všech dostupných flagů a umožňuje jejich výběr */
export class FlagFilter extends Control {
    //#region Fields
    /** Aktuálně vybrané barvy */
    private _selectedFlags: Array<Enum> = new Array<Enum>();
    /** Seznam všech dostupných barev */
    private _flagList: Array<string> = [];
    /** Slovník lokalizovaných názvů barev */
    private _flagColorsNameMap: Map<string, string> = new Map;
    //#endregion Fields

    //#region Properties
    public get value(): string {
        return this._selectedFlags.map((item) => Number(item)).join(",");
    }

    public set value(value: string) {
        this._selectedFlags = value.split(",").map((item) => Flags.flags[item]);
        this._render();
    }
    //#endregion Properties

    protected override _constructor(): void {
        super._constructor();

        Flags.loadingPromise.then(async (loadedFlags) => {
            if (loadedFlags) {
                this._flagList = Object.keys(loadedFlags);
                this._updateTitles();
            }
        });
    }

    //#region Methods
    /** Aktualizuje popisky flagů */
    private async _updateTitles(): Promise<void> { // [JB] TODO: Předělat na i18n jakmile bude dostupné
        const promises = this._flagList.map(
            async (flag) =>
                this._flagColorsNameMap.set(flag, await Flags.get(flag).getLocalizedName()),
        );

        await Promise.all(promises);
        this._render();
    }

    /** Aktualizuje vizuální stav komponenty */
    private _render(): void {
        const flags: Array<IFlagGroupColor> = this._flagList.map((color) => ({
            color: FlagUtils.flagToCss(color),
            isSelected: this._selectedFlags.includes(Flags.flags[color]),
            title: this._flagColorsNameMap.get(color),
        } as IFlagGroupColor));

        ReactDOM.render(React.createElement(FlagGroup, { flags, onChange: (color, isSelected) => this._onFlagSelectionChanged(color, isSelected) }), this);
    }

    /**
     * Handler, aktualizující seznam aktuálně vybraných flagů při kliku
     * @param color Flag, u kterého došlo ke změně
     * @param isSelected Zda byl označen/odznačen
     */
    private _onFlagSelectionChanged(color: string, isSelected: boolean): void {
        const changedFlag = this._flagList.find(flagColor => flagColor.toLowerCase().includes(color));
        if (isSelected) {
            this._selectedFlags.push(Flags.flags[changedFlag]);
        } else {
            this._selectedFlags.splice(this._selectedFlags.findIndex((item) => item.getName() === changedFlag), 1);
        }

        this._render();

        this.callEvent("change");
    }
    //#endregion Methods
}

registerCustomElement("tsc-FlagFilter", FlagFilter);
